/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import { Spacer } from 'bundles/enterprise-ui';

const styles = {
  arrow: css`
    width: 0;
    height: 0;
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    margin: auto var(--cds-spacing-100);
    display: inline-block;
  `,
  increasingArrow: css`
    border-bottom: 14px solid var(--cds-color-feedback-success);
  `,
  decreasingArrow: css`
    border-top: 14px solid var(--cds-color-feedback-error);
  `,
  neutralLine: css`
    width: 14px;
    height: 2px;
    margin: auto var(--cds-spacing-100);
    display: inline-block;
    background-color: var(--cds-color-neutral-primary-weak);
  `,
};

type Props = {
  percentageOfChange?: number;
  compact?: boolean;
};

const LearningInsightsPercentageArrow = ({ percentageOfChange, compact }: Props) => {
  if (percentageOfChange === undefined) {
    return null;
  } else if (percentageOfChange === 0) {
    return (
      <>
        <Typography2 component="span" color="supportText">
          {`${percentageOfChange}%`}
        </Typography2>
        {compact ? <Spacer size={8} /> : <div css={[styles.neutralLine]} />}
      </>
    );
  } else if (percentageOfChange < 0) {
    return (
      <>
        <Typography2 component="span" color="error">{`${percentageOfChange}%`}</Typography2>
        {compact ? <Spacer size={8} /> : <div css={[styles.arrow, styles.decreasingArrow]} />}
      </>
    );
  } else {
    return (
      <>
        <Typography2 component="span" color="success">{`+${percentageOfChange}%`}</Typography2>
        {compact ? <Spacer size={8} /> : <div css={[styles.arrow, styles.increasingArrow]} />}
      </>
    );
  }
};

export default LearningInsightsPercentageArrow;
